import * as Utils from "./utils";

class TrailingIndex {
  /*********************************************/
  /*************** 1.0: Animations *************/
  /*********************************************/

  constructor() {
    this.setupDefaults();
  }

  setupDefaults() {
    const images = document.querySelectorAll(".animate-me");

    var observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio > 0) {
          entry.target.classList.add("animationItem");
        } else {
          // entry.target.classList.remove('animationItem'); //animate when item leaves view
        }
      });
    });

    images.forEach((image) => {
      observer.observe(image);
    });

    //$("#mobile-subitems").append($(".generictab-bar .navbar-nav").html());
    //$("#mobile-expanded-subitems").append(
    //  $(".generictab-bar .navbar-nav").html()
    //);
    //$("#mobile-subitems .toggle-menu-item").remove();
    //$("#mobile-subitems").css({
    //  "list-style": "none",
    //});
    //$("#mobile-subitems a").addClass("btn-1");
    //$("#mobile-subitems-header").show();
    //$(".mobile-hr.sidenav-hr").show();
  }

  onReadyEvents() {
    $("#hot-items-news-view-reciever").append(
      $("#trending-view-identifier").html()
    );
    $("#Committees-news-view-reciever").append(
      $("#Committees-view-identifier").html()
    );
    $("#fast-references-news-view-reciever").append(
      $("#fast-references-view-identifier").html()
    );
    $("#debiefs-news-view-reciever").append(
      $("#debriefs-view-identifier").html()
    );
    $("#Domiciles-news-view-reciever").append(
      $("#Domiciles-view-identifier").html()
    );
    //$("#Domiciles2-news-view-reciever").append(
    //  $("#Domiciles2-view-identifier").html()
    //);
    $("#Departments-news-view-reciever").append(
      $("#Departments-view-identifier").html()
    );
    $("#Contacts-news-view-reciever").append(
      $("#Contacts-view-identifier").html()
    );
    //$("#hot-items-expanded-view-reciever").append(
    //  $("#trending-view-identifier").html()
    //);
    //$("#Committees-expanded-view-reciever").append(
    //  $("#Committees-view-identifier").html()
    //);
    //$("#fast-references-expanded-view-reciever").append(
    //  $("#fast-references-view-identifier").html()
    //);
    //$("#Domiciles-expanded-view-reciever").append(
    //  $("#Domiciles-view-identifier").html()
    //);
    //$("#Domiciles2-expanded-view-reciever").append(
    //  $("#Domiciles2-view-identifier").html()
    //);
    //$("#Departments-expanded-view-reciever").append(
    //  $("#Departments-view-identifier").html()
    //);
    //$("#Contacts-expanded-view-reciever").append(
    //  $("#Contacts-view-identifier").html()
    //);

    //Utils.getRecentSearches();
  }
}

export default TrailingIndex;
